export default __webpack_public_path__ + "static/media/itemC.facbea73.gif";